import {
    AfterViewInit,
    Component,
    ElementRef,
    OnInit,
    Renderer2,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BiddingUtils, InstructionData } from '@/vb-utils/bidding.util';
@Component({
    selector: 'vb-privacy-policy-page',
    templateUrl: './privacy-policy-page.component.html',
    styleUrls: ['./privacy-policy-page.component.css'],
})
export class PrivacyPolicyPageComponent implements OnInit, AfterViewInit {
    getPrivacyTxt: string = '';
    instruction?: InstructionData;
    constructor(
        private http: HttpClient,
        private renderer: Renderer2,
        private el: ElementRef,
        private readonly biddingUtils: BiddingUtils,
    ) {}

    ngOnInit(): void {
        this.http
            .get('./assets/viewbid/staticFiles/privacypolicy.txt', {
                responseType: 'text',
            })
            .subscribe((data: any): void => {
                this.getPrivacyTxt = data;
            });
        this.biddingUtils
            .getInstructionForCurrentPage$(window.location.href)
            .subscribe((instruction: InstructionData | null) => {
                this.instruction = instruction ?? undefined;
            });
    }

    // Manually applying styles to override the existing theme styles.
    // Since the content of privacypolicy.txt is rendered after CSS classes are applied,
    // inline styles must be applied directly to the inner HTML.
    ngAfterViewInit(): void {
        setTimeout(() => {
            const element: any = this.el.nativeElement.querySelectorAll(
                '.dynamic-content ul',
            );

            if (element) {
                const listItems: any = element.querySelectorAll('li');
                listItems.forEach((li: HTMLElement) => {
                    this.renderer.setStyle(li, 'margin-left', '15px');
                });
            }
        }, 100);
    }
}
